import { S3_FOLDER_URL } from "Config";
import _ from "i18n";
import moment from "moment";
import "moment/locale/fr";
import { TEMPLATE_TYPES } from "../constants";
import { formatDateFromTo, formatTime } from "./utils";

export const isEmpty = (value) => {
  if (Array.isArray(value) || typeof value === "string") {
    return value.length === 0;
  }
  if (typeof value === "object" && value !== null) {
    return Object.keys(value).length === 0;
  }
  return !value;
};
export function isUrl(str) {
  const regexp =
    /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;

  return regexp.test(str);
}

export const trimUrlSlashes = (url) => url.replace(/^\/+|\/+$/g, "");

export const prepareS3ResourceUrl = (
  baseS3Url,
  urlPath,
  appendEventsFolder = true,
) => {
  if (isUrl(urlPath ?? "")) return urlPath;
  if (isEmpty(baseS3Url) || isEmpty(urlPath) || !baseS3Url || !urlPath)
    return "";

  const base = trimUrlSlashes(baseS3Url);
  const path = trimUrlSlashes(urlPath).replace("eventsFolder", "events-folder");
  const pathPrefix =
    appendEventsFolder && path.split("/")[0] !== "events-folder"
      ? "events-folder"
      : "";

  return `${base}${isEmpty(pathPrefix) ? "/" : `/${pathPrefix}/`}${path}`;
};

export const formatFormation = (event) => {
  let {
    id,
    nameFr,
    isVirtual,
    eventDate,
    startDateTime,
    endDateTime,
    memberPrice,
    nonMemberPrice,
    clientData,
    languages,
    nameNl,
    nameEn,
  } = event;
  const getBannerImageUrl = (event) => {
    const imageUrl = event.urlBannerFr || event.pictureUrlFr;
    return prepareS3ResourceUrl(S3_FOLDER_URL, imageUrl);
  };

  const bannerImgUrl = getBannerImageUrl(event);
  let mode = "";
  let modeColor = "";

  if (event.type === "formation") {
    mode = isVirtual ? "PROCHAINEMENT EN live" : "PROCHAINEMENT EN Présentiel";
    modeColor = "#18a0fb";
  } else {
    const type = event.type?.toLowerCase();

    const typeLabels = {
      formation: isVirtual
        ? "PROCHAINEMENT EN live"
        : "PROCHAINEMENT EN Présentiel",
      saison: "SAISON",
      season: "SAISON",
      essentiel: "ESSENTIEL",
      essential: "ESSENTIEL",
      cycle: "CYCLE",
    };

    mode = typeLabels[type] || type?.toUpperCase();

    switch (type) {
      case "season":
        modeColor = "#f47f4d";
        break;
      case "essential":
        modeColor = "#14b7ad";
        break;
      case "cycle":
        modeColor = "#6f6cec";
        break;
      default:
        modeColor = "#18a0fb";
        break;
    }
  }

  const cycleType = (eventCycles = []) => {
    if (eventCycles.length === 0) {
      return "WEBINAR";
    }

    const allVirtual = eventCycles.every(
      (event) => event?.eventsAbstract?.isVirtual === 1,
    );
    const allPresential = eventCycles.every(
      (event) => event?.eventsAbstract?.isVirtual === 0,
    );

    if (allVirtual) return "WEBINAR";
    if (allPresential) return "PRESENTIAL";
    return "HYBRID";
  };

  let location = "";

  const isFormation = event.type === "formation";
  if (isFormation) {
    location = event.isVirtual ? "En live" : "Sur place";
  } else {
    const mode = cycleType(event.eventCycles);
    if (mode === "WEBINAR") {
      location = "En live";
    } else if (mode === "PRESENTIAL") {
      location = "Sur place";
    } else {
      location = "En live & sur place";
    }
  }
  let speakerEventName = "";
  let speakerEventFirstName = "";
  let speakerEventLastName = "";
  let speakerPhoto = "";

  let speakers = event["speakers-abstract"]?.speakers || [];

  if (speakers.length > 0) {
    let firstSpeaker = speakers[0];
    speakerEventFirstName = firstSpeaker.firstName || "";
    speakerEventLastName = firstSpeaker.lastName || "";
    speakerEventName =
      `${speakerEventFirstName} ${speakerEventLastName}`.trim();

    speakerPhoto = firstSpeaker.pictureUrl ? firstSpeaker.pictureUrl : "";
  }
  function formatCertifiedHours(hours) {
    if (!hours) return "";

    const totalMinutes = Math.round(parseFloat(hours) * 60);
    const h = Math.floor(totalMinutes / 60);
    const m = totalMinutes % 60;

    if (h && m) return `${h}h ${m}min d’attestations certifiées`;
    if (h) return `${h}h d’attestations certifiées`;
    if (m) return `${m}min d’attestations certifiées`;

    return "";
  }

  function formatEventCount(count) {
    if (!count) return "";
    return `${count} formation${count > 1 ? "s" : ""}`;
  }

  let totalCertified = formatCertifiedHours(event.totalCertifiedHours);
  let countFormations = formatEventCount(event.eventsCount);

  let eventUrl =
    event.urlBadgeFr && event.urlBadgeFr.startsWith("http")
      ? event.urlBadgeFr
      : "";

  const typeEventLabels = {
    formation: "LA FORMATION",
    cycle: "LE CYCLE",
    essential: "L'ESSENTIEL",
    season: "LA SAISON",
  };

  let typeEvent = typeEventLabels[event.type] || "";

  const defaultLogos = {
    9: "https://s3.tamtam.pro/local/storage/media/IMAGE/2174/AVATAR_54cbd68e1ba9284a1e486bd5d8551259cd51d96e.png",
    1256: "https://s3.tamtam.pro/local/storage/media/IMAGE/6348/AVATAR_e4fb37d14607091b2d1057ac4aa3b56c60e12f77.png",
  };

  let fiduciaireLogo = "";

  if (event.type === "formation") {
    fiduciaireLogo = event.clientData?.avatarUrl || "";
  } else {
    fiduciaireLogo = defaultLogos[event.client] || "";
  }

  let formattedEventDate = formatDateFromTo(startDateTime, endDateTime);

  let formattedStartTime = formatTime(startDateTime);

  let formattedEndTime = formatTime(endDateTime);

  let eventFormattedDate = "";
  if (startDateTime) {
    const startMoment = moment(startDateTime).locale("fr");
    const month = startMoment.format("MMM");
    const capitalizedMonth = month.charAt(0).toUpperCase() + month.slice(1);
    eventFormattedDate = `${startMoment.format("DD")} ${capitalizedMonth} ${startMoment.format("YY")}`;
  }

  let eventTimeRange = "";
  if (formattedStartTime && formattedEndTime) {
    eventTimeRange = `${formattedStartTime} à ${formattedEndTime}`;
  } else {
    eventTimeRange = formattedStartTime || formattedEndTime || "";
  }
  const parsedLanguages = JSON.parse(languages);
  const languageKey = Object.keys(parsedLanguages)[0].toLowerCase();

  function getSpeakerImageBlock(speakerPhoto) {
    if (!speakerPhoto) {
      return null;
    }

    return `
      <img
        src="${speakerPhoto}"
        alt="Speaker"
        width="26"
        height="26"
        style="border-radius: 50%; display: inline-block; background-color: #ffffff; vertical-align: middle;"
      >
  `;
  }
  const formattedBlockImg = getSpeakerImageBlock(speakerPhoto);
  return {
    id,
    type: TEMPLATE_TYPES["FORMATION_LAYOUT"],
    nameFr: nameFr || "",
    nameNl: nameNl || "",
    nameEn: nameEn || "",
    mode,
    speakerEventName,
    speakerEventFirstName,
    speakerEventLastName,
    speakerPhoto: formattedBlockImg,
    location,
    eventDate: formattedEventDate,
    eventFormattedDate,
    eventTimeRange,
    startTime: formattedStartTime,
    endTime: formattedEndTime,
    priceEvent:
      nonMemberPrice !== undefined && nonMemberPrice !== null
        ? `${nonMemberPrice}`
        : "0",
    memberPrice:
      memberPrice !== undefined && memberPrice !== null
        ? `${memberPrice}`
        : "0",
    url: eventUrl,
    fiduciaireLogo,
    eventImage: bannerImgUrl,
    urlEvent: `https://offfcourse.be/${languageKey}/${isFormation ? "event" : "cycle"}/${id}/reception`,
    modeColor,
    totalCertified,
    countFormations,
    typeEvent,
  };
};
